import styled from "styled-components";

export const StyledDropdownContainer = styled.div`
    position: relative;
    width: 116px;
    max-width: 116px;
`;
